<template>
  <div id="table-data-grid" >
    <vs-table
      ref="table"
      pagination
      :sst="sstValue"
      :data="data"
      :total="total"
      :max-items="itemsPage"
      search

      @search="searchTable"
      @change-page="refreshTable(itemsPage, currentPage, seachString)"
    >

      <div slot="header" class="flex flex-wrap-reverse items-center flex-grow justify-between">
        <!-- ITEMS PER PAGE -->
        <vs-dropdown vs-trigger-click class="cursor-pointer mb-4 mr-4">
          <div class="p-4 border border-solid d-theme-border-grey-light rounded-full d-theme-dark-bg cursor-pointer flex items-center justify-between font-medium">
            <span class="mr-2">{{ currentPage * itemsPage - (itemsPage - 1) }} - {{ total - currentPage * itemsPage > 0 ? currentPage * itemsPage : total }} / {{ total }}</span>
            <feather-icon icon="ChevronDownIcon" svgClasses="h-4 w-4" />
          </div>
          <vs-dropdown-menu>
            <vs-dropdown-item @click="changeItemsPerPage(6)">
              <span>6</span>
            </vs-dropdown-item>
            <vs-dropdown-item @click="changeItemsPerPage(10)">
              <span>10</span>
            </vs-dropdown-item>
            <vs-dropdown-item @click="changeItemsPerPage(15)">
              <span>15</span>
            </vs-dropdown-item>
            <vs-dropdown-item @click="changeItemsPerPage(20)">
              <span>20</span>
            </vs-dropdown-item>
          </vs-dropdown-menu>
        </vs-dropdown>
      </div>

      <template slot="thead">
        <vs-th :sort-key="column.dataField" v-if="column.visible" :key="index" :width="column.width"  v-for="(column, index) in dataColumns" >{{ column.caption }}</vs-th>
        <vs-th width="100"></vs-th>
      </template>

      <template slot-scope="{data}">
        <tbody>
        <vs-tr :data="item" :key="index" v-for="(item, index) in data">
          <td class="td vs-table--td" v-if="dataColumns[indexField].visible" data="field" :key="keyField" v-for="(field, keyField, indexField) in item" >
            <div v-if="dataColumns[indexField].dataType == 'slot'" >
              <slot :name="field" :item="item"  ></slot>
            </div>
            <span v-html="field" v-else ></span>
          </td>
          <td>
          <slot name="actions" :item="item" ></slot>
          </td>
        </vs-tr>
        </tbody>
      </template>
    </vs-table>
  </div>
</template>
<script>
    import esMessages from 'devextreme/localization/messages/es.json';
    import {locale, loadMessages} from 'devextreme/localization';

    export default {
        props: ['data', 'dataColumns', 'refreshTable', 'itemsPerPage', 'total'],
        data () {
            return {
                itemsPage: 0,
                selected: '',
                sstValue: true,
                isMounted: false
            }
        },
        computed: {
            currentPage () {
                if (this.isMounted) {
                    return this.$refs.table.currentx
                }
                return 0
            },
            seachString () {
              if (this.isMounted) {
                return this.$refs.table.searchx;
              }
              return '';
            }
        },
        mounted () {
            this.isMounted = true
        },
        created () {
            loadMessages(esMessages);
            locale('es');
            this.itemsPage = this.itemsPerPage;
        },
        methods: {
          changeItemsPerPage (value) {
            this.itemsPage = value;
            
            this.$refs.table.currentx = 1;
            this.refreshTable(this.itemsPage, this.currentPage, this.seachString);
          },
          searchTable () {
            this.$refs.table.currentx = 1;
            this.refreshTable(this.itemsPage, this.currentPage, this.seachString);
          }
        }
    }
</script>

<style lang="scss" >
  #table-data-grid {
    .vs-con-table {

      .product-name {
        max-width: 23rem;
      }

      .vs-table--header {
        display: flex;
        flex-wrap: wrap-reverse;
        margin-left: 1.5rem;
        margin-right: 1.5rem;
        > span {
          display: flex;
          flex-grow: 1;
        }

        .vs-table--search{
          padding-top: 0;

          .vs-table--search-input {
            padding: 0.9rem 2.5rem;
            font-size: 1rem;

            &+i {
              left: 1rem;
            }

            &:focus+i {
              left: 1rem;
            }
          }
        }
      }

      .vs-table {
        border-collapse: separate;
        border-spacing: 0 1.3rem;
        padding: 0 1rem;


        tr{
          box-shadow: 0 4px 20px 0 rgba(0,0,0,.05);
          td{
            padding: 10px;
            &:first-child{
              border-top-left-radius: .5rem;
              border-bottom-left-radius: .5rem;
            }
            &:last-child{
              border-top-right-radius: .5rem;
              border-bottom-right-radius: .5rem;
            }
            &.img-container {
              // width: 1rem;
              // background: #fff;

              span {
                display: flex;
                justify-content: flex-start;
              }

              .product-img {
                height: 110px;
              }
            }
          }
          td.td-check{
            padding: 20px !important;
          }
        }
      }

      .vs-table--thead{
        th {
          padding-top: 0;
          padding-bottom: 0;

          .vs-table-text{
            text-transform: uppercase;
            font-weight: 600;
          }
        }
        th.td-check{
          padding: 0 15px !important;
        }
        tr{
          background: none;
          box-shadow: none;
        }
      }

      .vs-table--pagination {
        justify-content: center;
      }
    }
  }
</style>
